<template>
  <v-menu
    v-model="pickDate"
    :close-on-content-click="false"
    :open-on-click="false"
    :close-on-click="false"
    v-bind="pickerPosition"
    offset-y
    min-width="fit-content"
  >
    <template v-slot:activator="{ on }">
      <FormInput
        :id="id"
        :icon="calendarIcon"
        :placeholder="placeholder"
        :error="error"
        :error-message="errorMessage"
        :value="value"
        :label-text="labelText"
        type="date"
        :required="required"
        v-on="on"
        @input="$emit('input', $event)"
        @focus="open"
      />
    </template>
    <v-date-picker
      v-on-click-outside="stop"
      show-adjacent-months
      :weekday-format="getDay"
      :value="value"
      :min="min"
      :locale="i18n.locale"
      :max="max"
      @input="$emit('input', $event)"
      @click:date="close"
    />
  </v-menu>
</template>

<script>
  import { VDatePicker, VMenu } from 'vuetify/lib';
  import FormInput from '@/components/ui/FormInput';
  import ClickOutside from 'vue-click-outside';
  import CalendarIcon from '@/assets/icons/calendar-2.svg';
  import t from '@/i18n';
  import { i18n } from '@/i18n';

  const daysOfWeek = [t('Mon'), t('Tue'), t('Wed'), t('Thu'), t('Fri'), t('Sat'), t('Sun')];

  export default {
    name: 'DatePickerInput',
    components: {
      VDatePicker,
      FormInput,
      VMenu,
    },
    props: {
      top: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      pickerPosition() {
        return {
          [this.top ? 'top' : 'bottom']: true,
        };
      },
    },
    directives: {
      ClickOutside,
    },
    extends: FormInput,
    data() {
      return {
        pickDate: false,
        calendarIcon: CalendarIcon,
        i18n,
      };
    },
    methods: {
      getDay(date) {
        let i = new Date(date).getDay(date);
        return daysOfWeek[i];
      },
      close() {
        this.pickDate = false;
      },
      open() {
        this.pickDate = true;
      },
      stop(event) {
        // бывают грязные костыли, а это чистый
        if (event.target.localName === 'input' || event.target.id === 'app')
          event.stopImmediatePropagation();
        else this.close();
      },
    },
  };
</script>
